﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const italianLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Activate: "Attiva",
  Actions_Add: "Aggiungere",
  Actions_AddBoard: "Aggiungi un organo",
  Actions_AddComment: "inserisci il commento",
  Actions_AddRun: "Crea una nuova attività",
  Actions_AddTopic: "Aggiungi trattanda",
  Actions_Back: "Di ritorno",
  Actions_Cancel: "Annullare",
  Actions_ChangeRunStatus: "Cambia stato",
  Actions_CreateEmail_Success: "Email creata correttamente.",
  Actions_Deactivate: "Disattiva",
  Actions_Delete: "Eliminare",
  Actions_DeleteBoard: "Cancellare organo",
  Actions_DeleteRun: "Cancellare l'attività",
  Actions_DeleteRunTopic: "Cancellare trattande",
  Actions_DownloadBoardsExcel: "Scaricare la lista dei organi",
  Actions_DownloadConfiguration: "Scarica la configurazione",
  Actions_DownloadFile: "Scarica il file '{name}' …",
  Actions_DownloadRunDocuments: "scarica lo zip con tutti i documenti",
  Actions_DownloadRunDocuments_Empty: "Non ci sono documenti da scaricare.",
  Actions_Edit: "Modifica",
  Actions_EditBoard: "Modifica organo",
  Actions_EditComment: "modifica il commento",
  Actions_EditRun: "Modificare l'attività",
  Actions_EditTopic: "Modifica trattanda",
  Actions_GoToBoard: "Alle configurazioni dell'organo",
  Actions_GoToRuns: "Sulle attività dell'organo",
  Actions_GoToVote: "Alla votazione",
  Actions_Help: "Aiuto",
  Actions_HideChildren: "Nascondi elementi subordinati",
  Actions_HideDiff: "Nascondi differenze",
  Actions_None: "Nessuna",
  Actions_Open: "Aprire",
  Actions_Opendocument: "apri documento",
  Actions_OpenPhonebook: "Aprire la rubrica telefonica",
  Actions_OpenUserProfile: "Aprire il profilo dell'utente",
  Actions_PublishRun: "Invia inviti e pubblica l'attività",
  Actions_Refresh: "Aggiorna",
  Actions_Reset: "Ripristinare",
  Actions_Save: "Salvare",
  Actions_SendEmail_Success: "Email inviata con successo.",
  Actions_SendReminders: "Invia promemoria",
  Actions_SendSiveResults_Failure: "Impossibile inviare il risultato a SiVe!",
  Actions_SendSiveResults_Success: "Risultato inviato a SiVe correttamente.",
  Actions_SendToSive: "Inviare i risultati a SiVe",
  Actions_ShowChildren: "Mostra elementi subordinati",
  Actions_ShowDiff: "Mostra differenze",
  Actions_Synchronize: "Sincronizzare",
  Actions_ToggleComments: "Visualizza commenti",
  Actions_ToggleResults: "Visualizzare i risultati",
  Actions_ToggleTopics: "Espandi/Collaudi tutti gli trattande",
  Actions_UploadDocument: "Aggiungi documento",
  Actions_View: "Dettagli",
  Actions_View_History: "Cronologia versioni",
  Actions_ViewHistory: "Visualizza la storia",
  AddUser_Label: "Inserire untente",
  AdminChart_Answered: "completamente risposto",
  AdminChart_NoResults: "Non c'è progresso",
  AdminChart_NotAnswered: "non o non completamente risposto",
  Administration_Restriction: "Devi essere amministratore per vedere quella pagina.",
  AdministratorsHaveAccessToo: "Anche gli amministratori esistenti dell'applicazione hanno accesso.",
  AdminUsersFilter_Placeholder: "Ricerca di utenti …",
  AliasOptional: "Alias (opzionale)",
  Answer_Abstention: "Astensione",
  Answer_Acknowledged: "Approvato",
  Answer_Discussion_Required: "Discussione richiesta",
  Answer_Group_Done: "Fatte",
  Answer_Group_Todo: "Da fare",
  Answer_No: "No",
  Answer_Not_Answer: "Nessuna risposta",
  Answer_Response_Abstention: "Astensione: {{totalAnswer}}",
  Answer_Response_Acknowledged: "Approvato: {{totalAnswer}}",
  Answer_Response_Discussion_Required: "Propongo una discussione: {{totalAnswer}}",
  Answer_Response_No: "No, non sono d'accordo con la proposta: {{totalAnswer}}",
  Answer_Response_Not_Answer: "Risposta non inoltrata: {{totalAnswer}}",
  Answer_Response_Yes: "Si, sono d'accordo con la proposta: {{totalAnswer}}",
  Answer_Response_Yes_But: "Si, ma: {{totalAnswer}}",
  Answer_Yes: "Si",
  Answer_Yes_But: "Si ma",
  App_Version: "Versione",
  ApplicationName: "eDecide",
  AuditLog: "Registro di audit",
  AuditLog_Action: "Action",
  AuditLog_Add: "Aggiunto",
  AuditLog_After: "Dopo",
  AuditLog_Before: "Prima",
  AuditLog_Changes: "Modifiche",
  AuditLog_Created: "Data",
  AuditLog_CreatedBy: "Utente",
  AuditLog_Date: "Su",
  AuditLog_Diff: "Differenze",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Campi",
  AuditLog_Property: "Campo",
  AuditLog_Remove: "Cancellato",
  AuditLog_State: "Azione",
  AuditLog_Update: "Modificato",
  AuditLog_User: "da",
  AuditLogs: "Registri di audit",
  Auth_Loading: "Caricamento dell'applicazione …",
  Auth_LoginFailed: "La verifica è fallita.",
  Auth_Redirecting: "Caricamento della verifica …",
  Auth_TryAgain: "Prova di nuovo.",
  BackHome: "Torna alla pagina iniziale",
  Board: "Organo",
  Board_Description: "Descrizione",
  Board_Members: "Membri",
  Board_Members_Add: "Aggiungi membro",
  Board_Name: "Nome",
  Board_Owners: "Proprietari",
  Board_Owners_Add: "Aggiungi proprietario",
  Board_RunThresholdDays: "Questionari archiviate più vecchie di  {{runThresholdDays}} giorni non vengono visualizzate",
  Board_Status: "Stato",
  Board_Statuses: "Stati",
  Board_TopicKindCodes: "Tipo di trattanda disponibili",
  Board_UniqueId: "Chiave",
  BoardConfiguration: "Configurazione",
  BoardConfiguration_Emailtemplate: "Modello per email",
  BoardConfiguration_ReportTemplate: "Modello per l'email",
  BoardRole: "Ruolo del organo",
  BoardRole_Member: "Membro",
  BoardRole_Owner: "Proprietario",
  BoardRoles: "Ruoli del organo",
  Boards: "Organi",
  Boards_Empty: "Nessun organo da mostrare.",
  Boards_NotFound: "Non sono stati trovati organi che rispondono a questi criteri",
  BoardStatus_Active: "attivo",
  BoardStatus_Archived: "archiviato",
  BoardStatus_Inactive: "inattivo",
  By: "da",
  Cancel: "Annulla",
  ClaimIssuer: "Emittente di rivendicazioni",
  Claims: "Rivendicazioni dell'utente",
  ClaimType: "Tipo di rivendicazion",
  Confirm: "Confermo",
  Confirm_Cancel: "Cancellare",
  Confirm_Content: "Sono state rilevate modifiche non salvate. Vuoi davvero ignorarle?",
  Confirm_DeleteBoard_Text: "Vuoi cancellare il organo {{name}}?",
  Confirm_DeleteEmailTemplate_Text: "Cancellare il modello per l'email {{name}}",
  Confirm_DeleteReportTemplate_Text: "Cancellare il protocolo {{name}}",
  Confirm_DeleteRun_Text: "Cancellare l'attività {{title}}?",
  Confirm_Discard: "Scartare le modifiche",
  Confirm_RunStatus_Change: "Conferma il cambiamento di stato da {oldStatus} a {newStatus}.",
  Confirm_RunStatus_Change_To_Archive_Title: "Archivare l'attività",
  Confirm_RunStatus_Change_To_Close: "Conferma il cambio di stato da '{oldStatus}' a 'Chiuso’. In caso di collegamento SiVe (ID esterno), i risultati vengono trasmessi automaticamente dopo la chiusura.",
  Confirm_RunStatus_Change_To_Close_Title: "Chiudere l'attività",
  Confirm_RunStatus_Change_To_Publish_Title: "Pubblicare l'attività",
  Confirm_RunStatus_Change_To_Revise: "Conferma il cambio di stato da «{oldStatus}» a «Verifica». Nello stato «Verifica» è possibile modificare le caratteristiche della corsa come data di fine e titolo nonché aggiungere nuovi partecipanti.",
  Confirm_RunStatus_Change_To_Revise_Title: "Rielaborare l'attività",
  Confirm_Title: "Modifiche non salvate",
  CopyToClipboard_Idle: "Copia negli appunti…",
  CopyToClipboard_Success: "Copia!",
  Created: "Creato",
  Date_Group_All: "Tutti",
  Date_Group_Oneyear: "massimo 1 anno",
  Date_Group_Twomonths: "massimo 2 mesi",
  Date_Group_Twoyears: "massimo 2 anni",
  Date_Unknown: "Data sconosciuta",
  De: "Tedesco",
  Details: "Dettagli",
  DismissableDialog_Close_Label: "Chiudere",
  DismissableDialog_Close_Tooltip: "Non visualizzare più il messaggio",
  Download: "Scaricare",
  Edit: "Modifica",
  Email_Invitation_Subject: "Attività eDecide {{run.title}}",
  Email_Reminder_Publish: `{{boardName}} - eDecide attività {{runTitle}}
Questo messaggio è stato generato automaticamente.<br><br>
Gentili partecipanti alla riunione,<br><br>
La procedura di votazione eDecide è stata avviata. Vota prima del {{expiryDate}} alle {{expiryTime}}.<br><br>
Cliccando sul link sottostante si accede direttamente alla votazione: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Cordiali saluti<br><br>
{{boardOwnerName}}<br>
Amministratore riunione<br><br>

============================REPUBLISH============================


{{boardName}} - eDecide attività {{runTitle}}
Questo messaggio è stato generato automaticamente.<br><br>
Gentili partecipanti alla riunione,<br><br>
La procedura di votazione eDecide è stata riaperta. Vota prima del {{expiryDate}} alle {{expiryTime}}.<br><br>
Cliccando sul link sottostante si accede direttamente alla votazione: <a href='{{voteLink}}'>{{runTitle}}</a><br><br>
Cordiali saluti<br><br>
{{boardOwnerName}}<br>
Amministratore riunione`,
  Email_Reminder_Subject: "Promemoria {{title}}",
  EmptyTable: "Nessun dato presente nella tabella",
  En: "Inglese",
  Entity: "Entità",
  Entity_Add_Failure: "Non è stato possibile creare {EntityName}.",
  Entity_Add_Success: "{EntityName} è stata creata con successo.",
  Entity_Delete_ConfirmContent: "Si vuole davvero cancellare {EntityName}?",
  Entity_Delete_ConfirmTitle: "Confermare l'eliminazione",
  Entity_Delete_Failure: "Non è stato possibile eliminare {EntityName}.",
  Entity_Delete_Success: "{EntityName} cancellato con successo.",
  Entity_Refresh_Failure: "Non è stato possibile ricaricare {EntityName}.",
  Entity_Refresh_Success: "{EntityName} ricaricato con successo.",
  Entity_Save_Failure: "Non è stato possibile salvare {EntityName}.",
  Entity_Save_Success: "{EntityName} salvato con successo.",
  Entity_Update_Failure: "Non è stato possibile aggiornare {EntityName}.",
  Entity_Update_Success: "{EntityName} aggiornato con successo.",
  EntityCount: "# Voci",
  EntityTitle_Unknown: "Sconosciuto",
  Error_FailedToAddUser: "Non è stato possibile aggiungere l'utente '{0}'.",
  ErrorCodes_BadRequest: "Qualcosa è andato storto con la query. Si tratta di un errore del client (ad esempio: sintassi errata della query, inquadramento non valido del messaggio di query o instradamento fuorviante della query).",
  ErrorCodes_InternalServerError: "Si è verificato un errore durante l'elaborazione della tue richiesta.",
  ErrorCodes_NoResponse: "Il servizio di backend non è disponibile.",
  ErrorCodes_NotFound: "La risorsa non è stata trovata.",
  ErrorCodes_Unauthorized: "Non hai i permessi per accedere alla risorsa.",
  Exception: "Eccezione",
  Exists: "Già presente",
  File_Picker_Not_Valid_File: "Formato non valido!",
  FileAction_Delete: "Verrà cancellato",
  FileAction_Existing: "Esistente",
  FileAction_New: "Verrà caricato",
  FileAction_Overwrite: "Verrà sovrascritto",
  FileUpload_ProtectedFile_Message: "Il file caricato «{0}» è stato riconosciuto come crittografato.",
  FileUpload_ProtectedFile_Title: "File protetto non sarà caricato",
  Filter_Active_Icon_Tooltip: "Modifica filtro",
  Filter_Clear_Icon_Tooltip: "Rimuovi filtro",
  Filter_Combobox_Filter_Customize: "Filtro",
  Filter_Icon_Tooltip: "Applica filtro",
  Filter_Search_Placeholder: "Cerca…",
  Footer_HelpAndSupport: "Aiuto & supporto",
  Footer_HelpTitle: "SBB eDecide Aiuto",
  Footer_Imprint: "Impronta",
  Footer_Title: "Impronta e aiuto",
  Fr: "Français",
  Group: "Gruppo",
  Group_Add: "Aggiungi gruppo",
  Group_AddError: "Impossibile aggiungere un gruppo",
  Group_AddSuccess: "Il gruppo è stato aggiunto con successo",
  Group_ConfirmDelete: "Volete davvero cancellare il gruppo?",
  Group_DeleteError: "Non è stato possibile cancellare il gruppo",
  Group_EntraIdName: "Nome nell’Entra ID",
  Group_EntraIdName_Description: "Collegando qui un gruppo Entra ID Group (Omada), i membri vengono importati periodicamente. Se non è definito alcun collegamento, i membri a destra possono essere eliminati e aggiunti.",
  Group_Id: "Id",
  Group_MemberCount: "# Membri",
  Group_Members: "Membri",
  Group_Name: "Nome",
  Group_Search: "Gruppo di ricerca …",
  Group_SearchStringHint: "È il nome del gruppo AD supportato.",
  Group_Titles: "Gruppi di annunci",
  GroupMember_ExistsInGroup: "Esiste nel gruppo",
  Groups: "Gruppi",
  Header_English: "Inglese",
  Header_French: "Francese",
  Header_German: "Tedesco",
  Header_Help: "Aiuto",
  Header_Italian: "Italiano",
  Header_Version: "Versione",
  Help: "Aiuto",
  HelpMenu_CosProductPage: "Prodotto COS eGPL 2",
  HelpMenu_Manuals: "Manuali",
  HelpMenu_Support: "Supporto",
  HelpMenu_VivaEngage: "Viva Engage group eGPL 2",
  Helppage: "Pagina di aiuto",
  Home: "Iniziale",
  Id: "Id",
  ImportedFromPhonebook: "Campi importati dalla rubrica telefonica",
  It: "Italiano",
  KeywordSearch: "Ricerca per parole chiave",
  LastModified: "Ultima modifica",
  LastModifiedBy: "Ultima modifica da",
  LastSync: "Ultima sincronizzazione",
  Loading: "Caricamento …",
  Logout: "Uscire",
  Message_Confirm_No: "NO",
  Message_Confirm_Question: "Sei sicuro di voler confermare l'azione?",
  Message_Confirm_Yes: "SI",
  Modified: "Modificato",
  Navigation_Administration: "Amministrazione",
  Navigation_All_Boards: "Tutti gli organi",
  Navigation_Completed_Votes: "Votazioni completate",
  Navigation_My_Boards: "I miei organi",
  Navigation_Open_Votes: "Votazioni aperte",
  No: "No",
  Ok: "OK",
  OpenLinkNewWindow: "Aprire il link (in una nuova finestra)",
  OriginalPath: "Percorso richiesta",
  Page_Admin_Title: "Amministrazione",
  Page_Board_Title: "Organo «{0}»",
  Page_BoardEdit_Title: "Gestione del organo «{{name}}»",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Title: "Dashboard",
  Page_Error_SubTitle: "Si è verificato un errore durante l'elaborazione della vostra richiesta.",
  Page_Error_Title: "Errore",
  Page_Group_Title: "Gruppo «{0}»",
  Page_Groups_Title: "Gruppi",
  Page_JobStatus_Title: "Stato del lavoro",
  Page_Mails_Title: "Test Inxmail",
  Page_Memory_Title: "Memoria",
  Page_Resources_Title: "Traduzioni",
  Page_Run_Title: "Attività «{{title}}»",
  Page_Translations_Title: "Traduzioni",
  Page_User_Title: "Utente «{0}»",
  Page_UserEdit_Title: "Modifica l'utente «{0}»",
  Page_Users_Title: "Utenti",
  Paging_First: "Inizio",
  Paging_Last: "Ultimo",
  Paging_Next: "Successivo",
  Paging_Previous: "Precedente",
  Paging_Stats: "Vista da _START_ a _END_ di _TOTAL_ elementi",
  Paging_StatsFiltered: "(filtrati da _MAX_ elementi totali)",
  Participant: "Partecipante",
  Participant_Answered_Stats: "ha risposto {{answered}}/{{totalTopic}}",
  Participant_Answers: "Risposte",
  Participant_Initials: "Iniziali",
  Participant_Name: "Name",
  Participant_Role: "Ruolo",
  Participant_Status: "Stato",
  Participants: "Partecipanti",
  Permissions: "Autorizzazioni",
  Personalisation: "Personalizzazione",
  Preview_Report: "Anteprima protocollo",
  Properties: "Caratteristiche",
  PublishRun_MailSubject: "Oggetto dell'email",
  PublishRun_MailSubject_Reminder_To_All: "Cari partecipanti all'attività,<br><br>",
  PublishRun_MailText: "Testo dell'email",
  PublishRun_SendTo: "Destinatario",
  PublishRun_SendType: "Metodo di spedizione",
  RequestId: "Richiesta ID",
  Reset: "ripristina",
  RichText_Link_Dialog_Title: "Modifica link",
  RichText_Link_Invalid_URL: "Inserisci un URL valido (https://, http://, mailto:)",
  RichText_Link_Remove: "Rimuovi link",
  RichText_Link_Text_Label: "Testo visualizzato",
  RichText_Link_URL_Label: "Destinazione",
  RichText_Paste_Cancel_Tooltip: "Annulla (annulla incolla)",
  RichText_Paste_KeepFormatting_Tooltip: "Mantieni la formattazione",
  RichText_Paste_Options_Trigger_Tooltip: "Opzioni di incolla (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Incolla come testo normale",
  Richtext_Placeholder: "Inserire testo …",
  RichText_Tooltip_Background: "Colore di sfondo",
  RichText_Tooltip_Blockquote: "Applicare il formato di giustificazione",
  RichText_Tooltip_Bold: "Grassetto (Ctrl+B)",
  RichText_Tooltip_Clean: "Cancellare il formato",
  RichText_Tooltip_Color: "Colore del testo",
  RichText_Tooltip_Heading: "Intestazione",
  RichText_Tooltip_Indent_Minus1: "Ridurre la gestione (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Aumentare la gestione (Tab)",
  RichText_Tooltip_Italic: "Corsivo (Ctrl+I)",
  RichText_Tooltip_Link: "Aggiungi un link",
  RichText_Tooltip_List_Bullet: "Aggiungere un elenco",
  RichText_Tooltip_List_Ordered: "Aggiungere un elenco numerato",
  RichText_Tooltip_Script_Sub: "Sottoscritto",
  RichText_Tooltip_Script_Super: "Superscritto",
  RichText_Tooltip_Size: "Dimensione del testo",
  RichText_Tooltip_Source: "Visualizza sorgente HTML",
  RichText_Tooltip_Strike: "Barrato",
  RichText_Tooltip_Underline: "Sottolineatura (Ctrl+U)",
  Run: "Attività",
  Run_ArchivedBy: "Archiviato da",
  Run_ArchiveType: "Tipo di archiviazione",
  Run_Boardname: "Organo",
  Run_ClosedBy: "Chiuso da",
  Run_ClosedDate: "Orario di chiusura (effettivo)",
  Run_CloseType: "Tipo di chiusura",
  Run_Comment: "Commento",
  Run_Expirydate: "Data di fine",
  Run_Expirytime: "Ora di fine",
  Run_Externalid: "Id esterno (SiVe)",
  Run_Key: "Id",
  Run_NotFound: "Non ci sono questionari da mostrare",
  Run_SiVeTransferResult: "Trasferimento SiVe",
  Run_Status: "Stato",
  Run_Title: "Titolo",
  RunParticipant: "Partecipante dell'attività",
  RunParticipant_NotFound: "Utente non disponibile",
  RunParticipants: "Partecipanti dell'attività",
  RunParticipants_Add: "Aggiungi partecipanti",
  RunParticipants_Invalid: "Lista dei partecipanti incorretta",
  RunParticipants_SearchMember: "Cerca membri del organo:",
  RunRole_AdditionalParticipant: "Partecipante aggiuntivo",
  Runs: "Attività",
  Runs_Empty: "Nessun attività disponibile.",
  RunStatus_All: "Tutti",
  RunStatus_Archived: "archiviato",
  RunStatus_ArchivedAndWillBeDeleted: "Archiviato, verrà eliminato il {0}",
  RunStatus_ClosedFromPublished: "chiuso",
  RunStatus_ClosedFromRepublished: "chiuso",
  RunStatus_Preparing: "preparazione",
  RunStatus_Published: "pubblicato",
  RunStatus_Republished: "ripubblicato",
  RunStatus_Unknown: "Sconosciuto",
  RunTopic: "Trattanda",
  RunTopic_Content: "Contenuto",
  RunTopic_Documents: "Lista dei documenti",
  RunTopic_InfoText: "Contenuto (Infotext)",
  RunTopic_Number: "Numero della trattanda",
  RunTopic_Question: "Contenuto (Question)",
  RunTopic_Result: "Risultato",
  RunTopic_Title: "Titolo della trattanda",
  RunTopic_TopicKindCode: "Tipo della trattanda",
  RunTopics: "Trattande",
  RunTopics_Empty: "Non ci sono ancora trattande.",
  RunTopicType_Agenda_Content: "Domanda per agenda",
  RunTopicType_Decision_Content: "Domanda",
  RunTopicType_Info_Content: "Testo",
  RunTopicType_Protocol_Content: "Domanda per il protocollo",
  RunTopicVote: "Risultato della votazione",
  RunTopicVotes: "Risultati della votazione",
  Save: "Salvare",
  Select_Placeholder: "Selezionare …",
  SelectAll: "Seleziona tutti",
  Send_Mail_Download: "scarica Email",
  Send_Mail_Publish: "Pubblica",
  Send_Mail_Send: "invia",
  Send_Mail_Send_Reminder_To_All: "Il ciclo di votazione eDecide è stato appena avviato. Si prega di votare prima della {{expiryDate}} al {{expiryTime}}.<br><br>",
  Send_Mail_Text: "Testo dell'email",
  SendTo_All: "Tutti (partecipanti e amministratori del organo)",
  SendTo_BoardOwners: "Amministratori del organo",
  SendTo_Participants: "Participanti",
  SendTo_ParticipantsWhoNotVoted: "Partecipanti che non hanno ancora votato",
  SendType_DoNotSend: "Non inviare email",
  SendType_Download: "Scaricare l'email e inviarla manualmente tramite Outlook",
  SendType_FromEdecide: "Inviare email direttamente da eDecide",
  Sive_MeetingDoesNotExist: "L'attività che vuoi chiudere non esiste più in SiVe!",
  Sive_MeetingMightBeDeleted: "La riunione in SiVe potrebbe non esistere più.",
  Sive_Result_IsSentOnClose: "I risultati verranno inviati a SiVe alla chiusura della attività.",
  Sive_ResultsWereSent: "I risultati sono stati inviati a SiVe alla chiusura della attività.",
  Sive_RunCreatedFromSive: "Questa attività è stata creata da una riunione in SiVe.",
  Statistics: "Statistiche",
  Status_All: "tutti",
  Status_Archived: "archiviato",
  Status_Button_Archive: "archivia",
  Status_Button_Close: "Chiudere l'attività",
  Status_Button_Publish: "pubblicare",
  Status_Button_Republish: "pubblicare nuovamente",
  Status_Button_Revise: "Rielaborare",
  Status_Closed: "chiuso",
  Status_Preparing: "preparazione",
  Status_Published: "pubblicato",
  Status_Republished: "ripubblicato",
  Status_Revise: "Verifica",
  StatusCode_401_SubTitle: "Non hai accesso alla risorsa.",
  StatusCode_401_Title: "Accesso negato",
  StatusCode_403_SubTitle: "Non hai i permessi per accedere alla risorsa.",
  StatusCode_403_Title: "Proibito",
  StatusCode_404_SubTitle: "La risorsa non è stata trovata.",
  StatusCode_404_Title: "Non trovato",
  Table_NoRows: "Nessun record trovato.",
  Tag_Old: "Veccio",
  Today: "Oggi",
  Topic_Agenda: "Agenda",
  Topic_Decision: "Decisione",
  Topic_Info: "Informazione",
  Topic_Protocol: "Protocollo",
  TopicCode_Agenda_Content: "Agenda",
  TopicCode_Protocol_Content: "Protocollo",
  Total: "Totale",
  User: "Utente",
  User_AnonymizedDisplayName: "Utente eliminato",
  User_Boards: "Organi",
  User_DisplayName: "Nome",
  User_Email: "E-mail",
  User_FirstName: "Nome",
  User_Initials: "Iniziali",
  User_Initials_HelpText: `Se lasci il campo vuoto, verrà applicato il valore predefinito.<br/>
Prima lettera del nome, prima lettera del cognome.`,
  User_Initials_Preview: "Aperçu",
  User_Language: "Lingua",
  User_LastName: "Cognome",
  User_LastSync: "Ultima sincronizzazione",
  User_OrganisationUnit: "Unità organizzativa",
  User_PersonalSiteUrl: "URL del sito MySite di SharePoint (OneDrive)",
  User_PersonnelNumber: "Nr. personale",
  User_Phone: "Telefono",
  User_Status: "Stato",
  User_Update_Error: "Non è stato possibile salvare l'utente: {0}",
  User_Update_Success: "L'utente è stato salvato",
  User_Upn: "Nome principale",
  User_UserRoles: "Ruoli",
  UserMenu_MyDetails: "Il mio profilo",
  UserMenu_SignOut: "Disconnessione",
  UserPicker: "Cerca utente",
  UserPicker_NoDataTemplate: "Nessun partecipante trovato",
  UserPicker_Placeholder: "Inserire l'identificatore …",
  UserRole_Administrator: "Amministratore",
  UserRole_Application: "Applicazione",
  UserRole_Unknown: "Utente",
  UserRole_User: "Sconosciuto",
  Users: "Utente",
  UserStatus_Deleted: "Cancellato",
  UserStatus_Enabled: "Attivo",
  UserStatus_Unknown: "Sconosciuto",
  Validation_At_Least_One_Owner: "Almeno un amministratore di organo.",
  Validation_Board_AtLeastOneBoardOwner: "Deve esserci almeno un amministratore del organo.",
  Validation_Board_AtLeastOneUser: "Deve esserci almeno un utente.",
  Validation_Board_DuplicateTopicKindCode: "Sono presenti tipi di trattande duplicati.",
  Validation_Board_InvalidTopicKindCode: "Sono presenti tipi di trattande non validi.",
  Validation_Board_NotUnique: "L'organo deve essere univoco. Verifica il campo 'Titolo'.",
  Validation_Board_UniqueKeySizeNot12: "'UniqueKey' deve essere lungo esattamente 12 caratteri.",
  Validation_Description_NotEmpty: "Il descrizione non deve essere vuoto.",
  Validation_ExpiryDate_Invalid: "Data non valida!",
  Validation_InvalidPosition: "Impossibile spostare. Posizione non valida.",
  Validation_Name_NotEmpty: "Il nome non deve essere vuoto.",
  Validation_Required: "'{PropertyName}' e richiesto.",
  Validation_Run_CodesNotUnique: "I numeri dei trattande devono essere univoci, duplicati: [{0}].",
  Validation_Run_NotUnique: "Un tema deve essere univoco nell'organo. Controlla il campo 'Titolo'.",
  Validation_RunTopic_NotUnique: "I trattande devono essere univoco nel corso. Verifica il campo 'Numero della trattanda'.",
  Validation_TextLongerThanRecommended: "Consigliato: non più di {{length}} caratteri.",
  Validation_Title_NotEmpty: "Il titolo non deve essere vuoto.",
  ValidationFailures: "Errore di validazione",
  VoteChart_Answered: "Trattande risposte",
  VoteChart_NotAnswered: "Trattande da rispondere",
  Votes_NotFound: "Non sono stati trovati voti con questi criteri",
  Voting_MyAnswer: "Mia risposta",
  Voting_MyComment: "Mio commento",
  Voting_RunNotPublished: "L'attività non è stato pubblicato.",
  Yes: "Sì",
};
